import { useStore } from 'effector-react'
import { useMemo } from 'react'
import { $currentStepFlags } from './stepModel'

export const useTitle = () => {
  const {
    isBasicInformationStep,
    isPassportStep,
    isDriverLicenseStep,
    isConfirmCodeStep,
    isSuccessStep,
    isErrorStep,
  } = useStore($currentStepFlags)

  const title = useMemo(() => {
    if (isBasicInformationStep) return 'Основная информация'
    if (isPassportStep) return 'Паспорт'
    if (isDriverLicenseStep) return 'Водительские права'
    if (isConfirmCodeStep) return 'Последний шаг!'
    if (isSuccessStep) return 'Регистрация завершена'
    if (isErrorStep) return 'Ошибка регистрации'

    return 'Регистрация'
  }, [
    isBasicInformationStep,
    isConfirmCodeStep,
    isDriverLicenseStep,
    isErrorStep,
    isPassportStep,
    isSuccessStep,
  ])

  return title
}
